module.exports = __webpack_public_path__ + "img/slogo.fe816c6f.svg";